<template>
<div v-if="show">
    <div class="header" :class="{'header-border': border, 'fixed': fixed,'bg': ShowBg}">
        <div class="left-btn" @click="$router.go(-1)">
            <img :src="Images.icon_arrow_left">
        </div>
        <span>{{title}}</span>
        <div class="right-btn" v-if="showRight">
            <solt></solt>
        </div>
    </div>
    <div class="header-blank" v-if="showBlank&&fixed"></div>
</div>
</template>

<script>
export default {
    name: "header-nav",
    props: {
        title: {
            type: String,
            default: '金钥匙'
        },
        show: {
            type: Boolean,
            default: false,
        },
        showRight: {
            type: Boolean,
            default: false
        },
        showBlank: {
            type: Boolean,
            default: true
        },
        border: {
            type: Boolean,
            default: true
        },
        fixed: {
            type: Boolean,
            default: true
        },
        ShowBg: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            ShowBgScroll: false,
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        listenerFunction(e) {
            document.addEventListener('scroll', this.handleScroll, true);
        },
        handleScroll () {
            if (window.pageYOffset > 10) {
                this.ShowBgScroll = true
            } else {
                this.ShowBgScroll = false
            }
        }
    },
    beforeDestroy () {
        document.removeEventListener("scroll", this.listenerFunction);
    },
    created () {
        this.listenerFunction()
    }
};
</script>

<style lang="less" scoped>
.header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
        font-size: 18px;
        color: #333,
    }
    .left-btn{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img{
            display: block;
            height: 20px;
            opacity: .8;
        }
    }
    .right-btn{
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: antiquewhite;
        img{
            display: block;
            height: 26px;
        }
    }
}
.fixed{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 110;
}
.bg{
    background-color: #fff;
}
.header-blank{
    height: 60px;
}
.header-border{
    border-bottom: solid 1px rgba(255, 255, 255, .4);
}
</style>
